import { MessageBox } from "element-ui";

const CURRENT_VERSION = process.env.VUE_APP_VERSION || "0.0.0";

let isChecking = false;
let hasShownUpdate = false;

function getVersionFileUrl() {
  const script = document.querySelector('script[src*="app."]');
  if (script && script.src) {
    return script.src.replace(/js\/[^/]+$/, "version.json");
  }

  const base = process.env.BASE_URL || "/";
  if (base.startsWith("http")) {
    return `${base.replace(/\/?$/, "/")}version.json`;
  }

  return `${window.location.origin}${base === "./" ? "/" : base}version.json`.replace(
    /([^:]\/)\/+/g,
    "$1"
  );
}

function showUpdateDialog() {
  MessageBox({
    title: "版本更新",
    message: `检测到新版本，请刷新页面以获取最新功能。`,
    type: "warning",
    showConfirmButton: true,
    showCancelButton: false,
    showClose: false,
    closeOnClickModal: false,
    closeOnPressEscape: false,
    confirmButtonText: "立即刷新",
    beforeClose: (action, instance, done) => {
      if (action === "confirm") {
        window.location.reload(true);
        return;
      }
      done();
    },
  });
}

export async function checkAppUpdate() {
  if (process.env.NODE_ENV === "development") {
    return;
  }

  if (isChecking || hasShownUpdate) {
    return;
  }

  isChecking = true;

  try {
    const response = await fetch(`${getVersionFileUrl()}?t=${Date.now()}`, {
      cache: "no-store",
    });

    if (!response.ok) {
      return;
    }

    const data = await response.json();
    if (data.version && data.version !== CURRENT_VERSION) {
      hasShownUpdate = true;
      showUpdateDialog(data.version);
    }
  } catch (error) {
    // 版本检查失败不影响正常使用
  } finally {
    isChecking = false;
  }
}
